// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb__item":"breadcrumb__item","split":"split"};